export function toNormalizedDate(value: Date | string | number | null | undefined): Date | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  const numericValue = typeof value === 'number' ? value : Number(value);
  const dateValue = !Number.isNaN(numericValue) && Number.isFinite(numericValue)
    ? normalizeEpoch(numericValue)
    : value;

  const date = new Date(dateValue);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatNormalizedDate(value: Date | string | number | null | undefined, locale = 'en-GB'): string {
  const date = toNormalizedDate(value);
  return date ? new Intl.DateTimeFormat(locale).format(date) : '';
}

function normalizeEpoch(value: number): number {
  return Math.abs(value) < 1_000_000_000_000 ? value * 1000 : value;
}
